export default __webpack_public_path__ + "static/media/Subscription.32f2e8f6.svg";